import React, { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'moment/locale/fr';
moment.locale('fr');

const localizer = momentLocalizer(moment);

const EventComponent = ({ event }) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <strong>{event.title}</strong>
            <span style={{ fontSize: '0.8em'}}>
                {moment(event.start).format('LT')} - {moment(event.end).format('LT')}
            </span>
        </div>
    );
};

const CalendarPage = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const authInstance = getAuth();
        const unsubscribe = onAuthStateChanged(authInstance, async (user) => {
            if (user) {
                user.getIdToken().then(token => {
                    fetchEvents(token);
                });
            }
        });

        // Unsubscribe on cleanup
        return () => unsubscribe();
    }, []);

    const fetchEvents = async () => {
    try {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (!userData || !userData.accessToken) {
            console.error('No access token available');
            return;
        }

        // Get the start and end of the current year
        const startOfYear = new Date(new Date().getFullYear(), 0, 1);
        const endOfYear = new Date(new Date().getFullYear(), 11, 31, 23, 59, 59);

        const response = await fetch(`https://www.googleapis.com/calendar/v3/calendars/primary/events?timeMin=${startOfYear.toISOString()}&timeMax=${endOfYear.toISOString()}`, {
            headers: {
                'Authorization': `Bearer ${userData.accessToken}`,
            },
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('response events:', data);
        
        const filteredEvents = data.items.filter(event => {
            const eventStart = new Date(event.start.dateTime || event.start.date);
            return eventStart >= startOfYear && eventStart <= endOfYear;
        });

        setEvents(filteredEvents);
    } catch (error) {
        console.error('Error fetching events', error);
    } finally {
        setLoading(false);
    }
};


    if (loading) {
        return (
            <Box className="flex justify-center items-center">
                <CircularProgress />
                <Typography variant="h6">Loading Events...</Typography>
            </Box>
        );
    }

    const handleEventClick = (event) => {
        const eventUrl = event.url;
        if (eventUrl) {
            window.open(eventUrl, '_blank');
        }
    };

    return (
        <Box m="1.5rem 2.5rem">
            <Calendar
                localizer={localizer}
                events={events.map(event => ({
                    title: event.summary,
                    start: new Date(event.start.dateTime || event.start.date),
                    end: new Date(event.end.dateTime || event.end.date),
                    url: event.htmlLink
                }))}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 800 }}
                onSelectEvent={handleEventClick}
                defaultView='week'
                views={['month', 'week', 'day', 'agenda']}
                components={{
                    event: EventComponent
                }}
            />
        </Box>
    );
};

export default CalendarPage;
